///
/// EarthBrowser
///
/// Created by Matt Giger on 10/18/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Build-time switches for shipped-but-not-yet-launched surfaces. Kept
/// dependency-free so data modules (onboarding steps) can import them
/// without pulling in redux.
///

/**
 * Story Tour authoring (Layers-panel entry, editor, onboarding step,
 * "Save story" on shared links). Hidden for the initial public release;
 * playback of shared stories (?s= / ?target=story-…) stays live, and the
 * stories slice + account sync keep running so existing stories survive
 * until authoring is re-enabled.
 */
export const cStoryAuthoringEnabled = false

/**
 * "Copy embed code" buttons (saved views in the layers panel and Views
 * browser, entity info panels). Hidden until the embed anti-extraction ops
 * gate is closed (tile URLs via the tile-server proxy, B2 bucket
 * restricted — see documentation/planning/EMBED_FEASIBILITY.md). The embed
 * page itself keeps working for snippets already in the wild.
 */
export const cEmbedCodeEnabled = false
